import { createSlice } from '@reduxjs/toolkit';
import { defaultMenuType, subHiddenBreakpoint, menuHiddenBreakpoint } from '../../constants/defaultValues';

const initialState = {
  containerClassnames: defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
  menuClickCount: 0,
  selectedMenuHasSubItems: defaultMenuType === "menu-default" // if you use menu-sub-hidden as default menu type, set value of this variable to false
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setContainerClassnamesAction: (state, action) => {
      const { clickIndex, strCurrentClasses, selectedMenuHasSubItems } = action.payload;
      const currentClasses = strCurrentClasses ? strCurrentClasses.split(' ').filter(x => x !== '') : '';
      let nextClasses = '';
      let adjustedClickIndex = clickIndex;

      if (!selectedMenuHasSubItems) {
        if (currentClasses.includes("menu-default") && (clickIndex % 4 === 0 || clickIndex % 4 === 3)) {
          adjustedClickIndex = 1;
        }
        if (currentClasses.includes("menu-sub-hidden") && (clickIndex % 4 === 2)) {
          adjustedClickIndex = 0;
        }
        if (currentClasses.includes("menu-hidden") && (clickIndex % 4 === 2 || clickIndex % 4 === 3)) {
          adjustedClickIndex = 0;
        }
      }

      if (adjustedClickIndex % 4 === 0) {
        if (currentClasses.includes('menu-default') && currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-default menu-sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden';
        }
        adjustedClickIndex = 0;
      } else if (adjustedClickIndex % 4 === 1) {
        if (currentClasses.includes('menu-default') && currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-default menu-sub-hidden main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary';
        }
      } else if (adjustedClickIndex % 4 === 2) {
        if (currentClasses.includes('menu-default') && currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-default menu-sub-hidden sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary sub-show-temporary';
        }
      } else if (adjustedClickIndex % 4 === 3) {
        if (currentClasses.includes('menu-default') && currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-default menu-sub-hidden sub-show-temporary';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden sub-show-temporary';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary';
        }
      }

      if (currentClasses.includes('menu-mobile')) {
        nextClasses += ' menu-mobile';
      }

      state.containerClassnames = nextClasses;
      state.menuClickCount = adjustedClickIndex;
    },

    clickOnMobileMenuAction: (state, action) => {
      const strCurrentClasses = action.payload;
      const currentClasses = strCurrentClasses ? strCurrentClasses.split(' ').filter(x => x !== '' && x !== 'sub-show-temporary') : '';
      let nextClasses = '';
      
      if (currentClasses.includes('main-show-temporary')) {
        nextClasses = (currentClasses.filter(x => x !== 'main-show-temporary')).join(' ');
      } else {
        nextClasses = currentClasses.join(' ') + ' main-show-temporary';
      }

      state.containerClassnames = nextClasses;
      state.menuClickCount = 0;
    },

    addContainerClassnameAction: (state, action) => {
      const { classname, strCurrentClasses } = action.payload;
      const newClasses = !strCurrentClasses.indexOf(classname) > -1 ? strCurrentClasses + ' ' + classname : strCurrentClasses;
      state.containerClassnames = newClasses;
    },

    changeDefaultClassnamesAction: (state, action) => {
      state.containerClassnames = action.payload;
    },

    changeSelectedMenuHasSubItemsAction: (state, action) => {
      state.selectedMenuHasSubItems = action.payload;
    }
  }
});

// Export the raw actions for internal use
export const {
  setContainerClassnamesAction,
  clickOnMobileMenuAction,
  addContainerClassnameAction,
  changeDefaultClassnamesAction,
  changeSelectedMenuHasSubItemsAction
} = menuSlice.actions;

// Create wrapper action creators that match the old API
export const setContainerClassnames = (clickIndex, strCurrentClasses, selectedMenuHasSubItems) => 
  setContainerClassnamesAction({ clickIndex, strCurrentClasses, selectedMenuHasSubItems });

export const clickOnMobileMenu = (strCurrentClasses) => 
  clickOnMobileMenuAction(strCurrentClasses);

export const addContainerClassname = (classname, strCurrentClasses) => 
  addContainerClassnameAction({ classname, strCurrentClasses });

export const changeDefaultClassnames = (strCurrentClasses) => 
  changeDefaultClassnamesAction(strCurrentClasses);

export const changeSelectedMenuHasSubItems = (payload) => 
  changeSelectedMenuHasSubItemsAction(payload);

export default menuSlice.reducer;